export const isGraphLoadingSelector = ({ balanceSheetManagement }) =>
  balanceSheetManagement.rateChangeWorkpaper.loading;

export const isSubmittingRowsSelector = ({ balanceSheetManagement }) =>
  balanceSheetManagement.rateChangeWorkpaper.submitting;

export const taxRateChangesSelector = ({ balanceSheetManagement }) =>
  balanceSheetManagement.rateChangeWorkpaper.taxRateChanges;
